export const actionTypes = {
  GET_EZD_INFO: "GET_EZD_INFO",
  SET_EZD_INFO: "SET_EZD_INFO",
  GET_FILTERED_EZD: "GET_FILTERED_EZD",
  SET_FILTERED_EZD: "SET_FILTERED_EZD",
  GET_EZD_BY_ID: "GET_EZD_BY_ID",
  SET_EZD_BY_ID: "SET_EZD_BY_ID",
  ADD_EZD_BRANCH: "ADD_EZD_BRANCH",
  GET_BRANCH_BY_ID: "GET_BRANCH_BY_ID",
  SET_BRANCH_BY_ID: "SET_BRANCH_BY_ID",
  EDIT_FORM_CHANGE: "EDIT_FORM_CHANGE",
  EDIT_EZD_BRANCH: "EDIT_EZD_BRANCH",
};

export const actions = {
  getEzdInfo: (payload) => ({
    type: actionTypes.GET_EZD_INFO,
    payload: payload,
  }),

  setEzdInfo: (payload) => ({
    type: actionTypes.SET_EZD_INFO,
    payload: payload,
  }),

  getFilteredEzd: (payload) => ({
    type: actionTypes.GET_FILTERED_EZD,
    payload: payload,
  }),

  setFilteredEzd: (payload) => ({
    type: actionTypes.SET_FILTERED_EZD,
    payload: payload,
  }),

  getEzdById: (payload) => ({
    type: actionTypes.GET_EZD_BY_ID,
    payload: payload,
  }),

  setEzdById: (payload) => ({
    type: actionTypes.SET_EZD_BY_ID,
    payload: payload,
  }),

  addEzdBranch: (payload) => ({
    type: actionTypes.ADD_EZD_BRANCH,
    payload: payload,
  }),

  getBranchById: (payload) => ({
    type: actionTypes.GET_BRANCH_BY_ID,
    payload: payload,
  }),

  setBranchById: (payload) => ({
    type: actionTypes.SET_BRANCH_BY_ID,
    payload: payload,
  }),

  editFormChange: (payload) => ({
    type: actionTypes.EDIT_FORM_CHANGE,
    payload: payload,
  }),

  editEzdBranch: (payload) => ({
    type: actionTypes.EDIT_EZD_BRANCH,
    payload: payload,
  }),
};
